import type { Estates } from '@/features/estates/api/estates';
import type { Projects } from '@/features/projects/api/projects';

import { type Currency, getPriceWithCurrency, type Locale } from './getPriceWithCurrency';

type EstatePrice =
  | {
      prices?: Projects[number]['prices'] | Estates[number]['prices'] | null;
    }
  | null
  | undefined;

export const getFinalPrice = (estate: EstatePrice, language: Locale = 'de-DE') => {
  if (!estate || !estate.prices) return '';
  if ('min' in estate.prices) {
    if (estate.prices.max !== null) {
      return `${getPriceWithCurrency(estate.prices.min, 'EUR', language)} - ${getPriceWithCurrency(estate.prices.max, 'EUR', language)}`;
    } else {
      return getPriceWithCurrency(estate.prices.min, 'EUR', language);
    }
  }
  return getPriceWithCurrency(
    estate.prices?.buyingPrice,
    estate.prices?.currency as Currency,
    language
  );
};
